/* eslint-disable */
import OrderAPI from "./data";

const state = {
  edit: null,
};

// getters
const getters = {};

// actions
const actions = {
  get: (context, key) => {
    return OrderAPI.get(context, key).then(order => {
      context.commit("SET_EDIT_ORDER", order);
      return order;
    });
  },
  refundOrder: (context, key, amount) => {
    // context.commit("SET_LOADING", true);
    // api(context)
    //   .get(context.state.prev)
    //   .then(response => response.data)
    //   .then(data => {
    //     context.commit("DEFAULT_API_RESPONSE", data);
    //   })
    //   .catch(error => {
    //     console.log(error);
    //     console.log("ERROR");
    //   })
    //   .finally(() => {
    //     context.commit("SET_LOADING", false);
    //   });
  },
  update: (context, order) => {
    return OrderAPI.update(context, order).then(order => {
      context.commit("SET_EDIT_ORDER", order);
      return order;
    });
  },
  export: (context, query) => {
    return OrderAPI.export(context, query);
  },
  voidOrder: (context, orderKey) => {
    return OrderAPI.voidOrder(context, orderKey);
  },
  printOrder: (context, printJob) => {
    return OrderAPI.printOrder(
      context,
      printJob.orderKey,
      printJob.printType,
      printJob.printCount
    );
  },
  getTransactionHistory: (context, orderKey) => {
    return OrderAPI.getTransactionHistory(context, orderKey);
  }
};

// mutations
const mutations = {
  SET_EDIT_ORDER(state, order) {
    state.edit = order;
  },
};

export default { namespaced: true, state, getters, actions, mutations };
